// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"d73d0a0c","453":"03b761cf","551":"968a79d3","965":"df5a9ef9"}[chunkId] + ".chunk.js";
};